import { Grid } from '@mui/material';
import { FileTypeEnum } from 'remote/global';
import FormCard from 'components/FormCard';
import { useTranslation } from 'react-i18next';
import VehicleDetailsForm from 'components/forms/FleetFormFactory/VehicleDetailsForm';
import VehicleExtrasForm from 'components/forms/FleetFormFactory/VehicleExtrasForm';
import VehicleImageForm from 'components/forms/FleetFormFactory/VehicleImageForm';
import { useOperatorsVehiclesFilesQuery, useOperatorsVehiclesQuery } from 'api/queries/operators';
import { useParams } from 'react-router-dom';

function VehicleDetailView() {
  const { id } = useParams();
  const { data: vehicle, isSuccess: isVehicleSuccess } = useOperatorsVehiclesQuery(id!);
  const { data: files, isSuccess: isFilesSuccess } = useOperatorsVehiclesFilesQuery(id!);
  const { t } = useTranslation();
  if (!isVehicleSuccess || !isFilesSuccess) return null;

  const vehicleFiles = files.filter((f) => f.fileType === FileTypeEnum.VEHICLE_PHOTO);

  return (
    <Grid item container spacing={3}>
      <Grid item width='421px' textAlign='left'>
        <FormCard title={t('FleetView.DetailView.vehicleDetails.title')}>
          <VehicleDetailsForm vehicle={vehicle} defaultValues={vehicle} />
        </FormCard>
      </Grid>
      <Grid item width='421px' textAlign='left'>
        <FormCard title={t('FleetView.DetailView.vehicleExtras.title')}>
          <VehicleExtrasForm defaultValues={vehicle} vehicle={vehicle} />
        </FormCard>
      </Grid>
      <Grid item width='421px' textAlign='left'>
        <FormCard title={t('FleetView.DetailView.vehicleImages.title')}>
          <VehicleImageForm
            vehicleId={String(vehicle.id)}
            defaultValues={{
              attachments: vehicleFiles,
            }}
          />
        </FormCard>
      </Grid>
    </Grid>
  );
}

export default VehicleDetailView;
